import { merge } from "lodash";

import { EAR_MOLD_SUBTYPE, RECEIVER_SUBTYPE } from "constants/products";
import {
  ACCESSORY_PRODUCT_TYPE,
  COCHLEAR_IMPLANT_PRODUCT_TYPE,
  HEARING_AID_PRODUCT_TYPE
} from "constants/sales";
import { Product, ProductCatalogOption } from "services/types/products.type";

import { InventoryProduct } from "../services/types/inventory-products.type";

// Mirrors the backend's `MasterProduct.is_serialized`: hearing aids and cochlear
// implants are single physical units, as are earmolds (and receivers, where the
// caller counts them). Cochlear implants were missing, so they were treated as
// bulk-quantity stock and never asked for a serial number.
export function isSerializedProduct(
  type?: number,
  subtype?: number | null,
  includeReceiver = true,
  isExistingHA = false
) {
  return Boolean(
    !isExistingHA &&
      ([HEARING_AID_PRODUCT_TYPE, COCHLEAR_IMPLANT_PRODUCT_TYPE].includes(
        Number(type)
      ) ||
        (type === ACCESSORY_PRODUCT_TYPE &&
          (subtype === EAR_MOLD_SUBTYPE ||
            (subtype === RECEIVER_SUBTYPE && includeReceiver))))
  );
}

// TODO: Replace this with product has Inventory specifications
export function isReceiver(product: Product) {
  const {
    master_product: { type, subtype }
  } = product;
  return Boolean(
    type === ACCESSORY_PRODUCT_TYPE && subtype === RECEIVER_SUBTYPE
  );
}

export function formatProductCatalogOption(products: Product[]) {
  const result: ProductCatalogOption[] = [];

  products.forEach((product) => {
    const option: ProductCatalogOption = {
      ...product,
      is_serialized: isSerializedProduct(
        product?.master_product?.type,
        product?.master_product?.subtype
      )
    };
    result.push(option);
  });

  return result;
}

export function formatInventoryProductToProductCatalogOption(
  inventoryProduct: InventoryProduct | null | undefined
): ProductCatalogOption | null {
  if (!inventoryProduct) {
    return null;
  }
  const { product, ...inventory_product } = inventoryProduct;
  const inventory_option: ProductCatalogOption = structuredClone(product);

  inventory_option.inventory_specification = merge(
    {},
    product.master_product?.specification,
    inventoryProduct?.specification || {}
  ) as any;

  inventory_option.serial_number = inventory_product.serial_number;
  inventory_option.inventory_id = inventory_product.id;
  inventory_option.available_quantity = inventory_product.available_quantity;
  inventory_option.demoable = inventory_product.demoable;
  inventory_option.loanable = inventory_product.loanable;

  return inventory_option;
}
